import { Component, OnInit } from "@angular/core";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { TarefasProtocoloService } from "./tarefas-protocolo.service";




@Component({
    selector: 'app-tarefas-protocolo',
    templateUrl: './tarefas-protocolo.component.html',
    styleUrls: ['./tarefas-protocolo.component.scss'],
    standalone: false
})
export class TarefasProtocoloComponent implements OnInit {

  public data: Date;
  public dataSistema: Date;

  constructor(
    private protocoloService: TarefasProtocoloService,
    private messageService: MessageChannelService,
    private alertService: BnAlertsService,
    private loadingService: BnLoadingService,
    private fileUtils: FileUtilsService,) {
  }

  ngOnInit(): void {
   
  }

  public cancelarProtocolosEmValidacao() {
    this.loadingService.bloqueiaTela();
      this.protocoloService.cancelarProtocolosEmValidacao().subscribe((msgRetorno) => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: msgRetorno.mensagem
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }
}
